import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography, Checkbox, FormControlLabel, Divider, Tooltip } from "@mui/material";
import React from "react";
import { uppercaseFirst } from "../utils";
import SearchIcon from '@mui/icons-material/Search';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { colorTextInactive } from "../App/theme";
import { searchProps } from "./contants";

function propToType(str) {
    return str.replace(/\d+$/, '');
}

export const EditAttribute = ({ editAttribute, setEditAttribute, handleEditCreate, itemTypeToCreate }) => {
    if (!editAttribute || !editAttribute.attrType) return null;

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleEditCreate();
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    };

    const handleCheckboxChange = (field) => (event) => {
        setEditAttribute({ ...editAttribute, [field]: event.target.checked });
    };

    return (
        <Dialog open={Boolean(editAttribute)} onClose={() => setEditAttribute(null)}>
            <DialogTitle>Edit Attribute</DialogTitle>
            <DialogContent>
                <TextField
                    required={true}
                    autoFocus
                    margin="dense"
                    label="Attribute Name"
                    type="text"
                    fullWidth
                    value={editAttribute.attrName}
                    onChange={(e) => {
                        setEditAttribute({
                            ...editAttribute,
                            attrName: e.target.value,
                            label: uppercaseFirst(e.target.value),
                            placeholder: 'Enter' + (itemTypeToCreate
                                ? (' ' + itemTypeToCreate.toLowerCase() + ' ')
                                : ' ') + e.target.value,
                            unit: editAttribute?.unit,
                        });
                    }}
                    onKeyDown={handleKeyDown}
                />

                <Divider sx={{ mt: 4, mb: 4 }}>Optional Settings</Divider>

                {editAttribute?.attrType !== 'itemId' && <Tooltip title={editAttribute.encrypted
                    ? "Stored encrypted with your personal AES key"
                    : "Stored in plain text"}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={editAttribute.encrypted || false}
                                onChange={handleCheckboxChange('encrypted')}
                            />
                        }
                        label={"Encrypted"}
                    />
                </Tooltip>}

                {/*{editAttribute?.attrType !== 'itemId' && <Tooltip title={editAttribute.encrypted*/}
                {/*    ? "Structured search is not available for encrypted fields."*/}
                {/*    : `Searchable as ${searchProps[editAttribute?.attrType].type}`} >*/}
                {/*    <span>*/}
                {/*        <FormControlLabel*/}
                {/*            control={*/}
                {/*                <Checkbox*/}
                {/*                    icon={<SearchOffIcon style={{ color: colorTextInactive }} />}*/}
                {/*                    checkedIcon={<SearchIcon />}*/}
                {/*                    checked={!editAttribute.encrypted}*/}
                {/*                    onChange={handleCheckboxChange('structuredSearch')}*/}
                {/*                    disabled={editAttribute.encrypted}*/}
                {/*                />*/}
                {/*            }*/}
                {/*            label="Structured Search"*/}
                {/*        />*/}
                {/*    </span>*/}
                {/*</Tooltip>}*/}

                <TextField
                    margin="dense"
                    label="Unit"
                    type="text"
                    fullWidth
                    value={editAttribute.unit || ''}
                    onChange={(e) => setEditAttribute({ ...editAttribute, unit: e.target.value })}
                    onKeyDown={handleKeyDown}
                />

                <TextField
                    margin="dense"
                    label="Input Label"
                    type="text"
                    fullWidth
                    value={editAttribute.label || ''}
                    onChange={(e) => setEditAttribute({ ...editAttribute, label: e.target.value })}
                    onKeyDown={handleKeyDown}
                />
                <TextField
                    margin="dense"
                    label="Input Placeholder"
                    type="text"
                    fullWidth
                    value={editAttribute.placeholder || ''}
                    onChange={(e) => setEditAttribute({ ...editAttribute, placeholder: e.target.value })}
                    onKeyDown={handleKeyDown}
                />
                <TextField
                    disabled={true}
                    margin="dense"
                    label="Type"
                    type="text"
                    fullWidth
                    value={propToType(editAttribute.attrType) || ''}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setEditAttribute(null)} color="primary">
                    Cancel
                </Button>
                <Button disabled={!editAttribute?.attrName} onClick={handleEditCreate} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};